import Axios from 'axios';

export default function (personalNumber) {
    return Axios.post('/register/api/personal-details', {
        value: personalNumber
    }).then((result) => result.data);
}
